var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOemIcon = function SvgOemIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E562E3",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M10 14.375a4.375 4.375 0 1 0 0-8.75 4.375 4.375 0 0 0 0 8.75ZM5.417 10H1.458M18.542 10h-3.959"
  })));
};
export { SvgOemIcon as ReactComponent };
export default __webpack_public_path__ + "4f24b575260ff670abbcceb9bb1df7ff.svg";